import { IApplicationState } from '../../types/redux';

/**
 * Выбирает список seo-урлов для карточки поста
 */
export const selectSeoUrls = ({ seoUrlsNew }: IApplicationState) => seoUrlsNew;
